import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_READER = "access-control-service/readers";

const RESOURCES = {
   PAGINATED_READERS: (page, searchText, model, condominiumId, orderBy, synchronizable) => {
      const params = {
         page,
         limit: 8,
      };
      if (orderBy) {
         params.orderBy = orderBy?.collumnTitle;
         params.orderDirection = orderBy?.orderDirection;
      }
      if (model) {
         params.model = model;
      }
      if (searchText) {
         params.searchBy = searchText;
      }
      if (synchronizable !== null) {
         params.synchronizable = synchronizable;
      }
      const urlParams = new URLSearchParams(params);
      return `${BASE_READER}/condominiums/${condominiumId}/paginated?${urlParams.toString()}`;
   },
   PAGINATED_READERS_BY_ACCESSES: (page, searchText, model, condominiumId, orderBy) => {
      const params = {
         page,
         limit: 8,
      };
      if (orderBy) {
         params.orderBy = orderBy?.collumnTitle;
         params.orderDirection = orderBy?.orderDirection;
      }
      if (model) {
         params.model = model;
      }
      if (searchText) {
         params.searchBy = searchText;
      }
      const urlParams = new URLSearchParams(params);
      return `${BASE_READER}/condominiums/${condominiumId}/accesses/paginated?${urlParams.toString()}`;
   },
   CREATE_READER: () => `${BASE_READER}`,
   UPDATE_READER: (id) => `${BASE_READER}/${id}`,
   DELETE_READER: (id) => `${BASE_READER}/${id}`,
   READERS_OPERATION: (idCondominium, licenseId, operation) => `${BASE_READER}/operation/${idCondominium}/${licenseId}/${operation}`,
   UPDATE_READER_SERVICE_CONFIG: (model, idCondominium, licenseId) => `access-control-service/reader-service-configurations/${model}/${idCondominium}/${licenseId}`,
   GET_READER_SERVICE_CONFIG: (model, idCondominium, licenseId) => `access-control-service/reader-service-configurations/${model}/${idCondominium}/${licenseId}`,
   LIST_READERS_BY_CONDOMINIUM: (idCondominium) => `${BASE_READER}/condominiums/${idCondominium}`,
   LIST_READERS_BY_USER_AND_CONDOMINIUM: (idCondominium, userId) => `${BASE_READER}/condominiums/${idCondominium}/condo-users/${userId}/readers`,
};

class ReadersService {
   static async getPaginatedReaders(page, searchText, model, condominiumId, orderBy, cancelToken, synchronizable = null) {
      try {
         return await axios.get(
            RESOURCES.PAGINATED_READERS(page, searchText, model, condominiumId, orderBy, synchronizable),
            {
               signal: cancelToken,
            }
         );
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar leitoras paginadas",
         });
         return error.response;
      }
   }

   static async getPaginatedReadersByAccesses(page, searchText, model, condominiumId, orderBy, groupsUuids, accessesUuids) {
      try {
         return await axios.post(
            RESOURCES.PAGINATED_READERS_BY_ACCESSES(page, searchText, model, condominiumId, orderBy),
            {
               groupsUuids,
               accessesUuids,
            }
         );
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar leitoras por acessos paginadas",
         });
         return error.response;
      }
   }

   static async listReadersByCondominium(idCondominium) {
      try {
         return await axios.get(RESOURCES.LIST_READERS_BY_CONDOMINIUM(idCondominium));
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar leitoras por condomínio",
         });
         return error.response;
      }
   }

   static async listReadersByUserAndCondominium(idCondominium, userId) {
      try {
         return await axios.get(RESOURCES.LIST_READERS_BY_USER_AND_CONDOMINIUM(idCondominium, userId));
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar leitoras por usuário e condomínio",
         });
         return error.response;
      }
   }

   static async createReader(payload) {
      try {
         const response = await axios.post(RESOURCES.CREATE_READER(), payload);
         ResponseAlerts({
            response,
            successMessage: "Leitora criada com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao criar leitora",
         });
         return error.response;
      }
   }

   static async updateReader(id, payload) {
      try {
         const response = await axios.put(RESOURCES.UPDATE_READER(id), payload);
         ResponseAlerts({
            response,
            successMessage: "Leitora atualizada com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao atualizar leitora",
         });
         return error.response;
      }
   }

   static async deleteReader(id) {
      try {
         const response = await axios.delete(RESOURCES.DELETE_READER(id));
         ResponseAlerts({
            response,
            successMessage: "Leitora removida com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao remover leitora",
         });
         return error.response;
      }
   }

   static async updateReaderServiceConfig(model, idCondominium, licenseId, payload) {
      try {
         const response = await axios.put(RESOURCES.UPDATE_READER_SERVICE_CONFIG(model, idCondominium, licenseId), payload);
         ResponseAlerts({
            response,
            successMessage: "Configuração da leitora atualizada com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao atualizar configuração da leitora",
         });
         return error.response;
      }
   }

   static async getReaderServiceConfig(model, idCondominium, licenseId) {
      if (!idCondominium || !licenseId) {
         return;
      }
      try {
         return await axios.get(RESOURCES.GET_READER_SERVICE_CONFIG(model, idCondominium, licenseId));
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao buscar configuração da leitora",
         });
         return error.response;
      }
   }

   static async sendReadersOperation(idCondominium, licenseId, operation, payload) {
      try {
         const response = await axios.post(RESOURCES.READERS_OPERATION(idCondominium, licenseId, operation), payload);
         ResponseAlerts({
            response,
            successMessage: "Operação enviada com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao executar operação",
         });
         return error.response;
      }
   }
}

export default ReadersService;
